import type { CoreQuestionResource } from '@dmp/qqms/data-access';
import type { StoreState } from '../../state-types';

/** Get Core Question by core question `shortId` */
export const getCoreQuestionByShortId =
    (shortId: string) =>
    (state: StoreState): CoreQuestionResource | undefined =>
        Object.values(state.coreQuestions).find(
            (cq) => cq.attributes.shortId === shortId
        );
